import { AddNewButtonShell } from '@/components/RootScreenButtons/buildingBlocks/AddNewButtonShell';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';
import { cleanLocalStorageKey } from '@/utils/cleanLocalStorageKey';

export const AddNewOrderButton = () => {
  const t = useTranslation();
  const { push } = useAppPush();
  return (
    <AddNewButtonShell
      onClick={() => {
        cleanLocalStorageKey('ORDER_FORM');
        push('/orders/new?orderEditOrigin=root');
      }}
    >
      {t('section.ADD_NEW_ORDER')}
    </AddNewButtonShell>
  );
};
